module.exports = __webpack_public_path__ + "static/media/GraduationHat.5f7ef656.svg";